import { Chip, Divider, MenuItem, MenuList } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useGlobalTimeSliderContext } from '../../../context/contexts';
import { now } from '../../../date/date-utils';
import { enumKeys } from '../../../utils';
import { Menu } from './Menu';

const StyledMenuItem = styled(MenuItem)`
  padding-top: 2px;
  padding-bottom: 2px;
  & .Mui-selected {
    background-color: rgb(0, 150, 153);
  }
`;

const StyledDivider = styled(Divider)`
  font-weight: 800;

  & .MuiDivider-wrapper {
    margin: 0;
    padding: 0;
  }
  & ::before,
  & ::after {
    border-top: 1px solid white;
  }
`;

const StyledChip = styled(Chip)`
  margin: 0;
  color: white;
  border: white;

  & .MuiChip-label {
    padding: 0;
  }
`;

const menuLabel = (label: string) => `common:timeSlider.presets.${label}`;

export const PresetPicker = () => {
  const { t } = useTranslation();
  const timeSliderHandle = useGlobalTimeSliderContext();
  const [state, dispatch] = timeSliderHandle;
  const granularityInfoKeys = enumKeys(state.granularityInfo);
  return (
    <Menu label={t('common:timeSlider.presets.presets')}>
      {granularityInfoKeys.map((granularity) => {
        const info = state.granularityInfo[granularity];
        return (
          <MenuList
            key={granularity}
            sx={{ paddingTop: '4px', paddingBottom: '4px' }}
          >
            {/* <StyledDivider textAlign="left"> */}
            <StyledChip
              label={t(`common:timeSlider.steps.${info.granularity.label}`)}
              size="small"
              variant="outlined"
              sx={{ paddingLeft: 1, fontWeight: 'bold' }}
            />
            {/* </StyledDivider> */}
            {info.availablePresets.map((preset) => (
              <StyledMenuItem
                key={`preset-picker-${preset.id}`}
                onClick={() =>
                  dispatch({
                    type: 'update-preset',
                    granularity: info.granularity,
                    preset,
                    current: now(),
                  })
                }
                style={{ color: 'inherit' }}
              >
                {t(menuLabel(preset.label))}
              </StyledMenuItem>
            ))}
          </MenuList>
        );
      })}
    </Menu>
  );
};
